import React, { Component } from 'react';
import "../css/orderAction.css";

import { faCircleInfo, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
export class OrderAction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInput: "",
            codeConfirmed: false,
            checkedSlots: [], // index-based flags
            errorMsg: "",     // holds wrong-code message
            showInstructions: false 
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.toggleSlot = this.toggleSlot.bind(this);
        this.toggleInstructions = this.toggleInstructions.bind(this);
    }

    componentDidMount() {
        const { currentOrderAction } = this.props;
        const slots = Array.isArray(currentOrderAction?.slots) ? currentOrderAction.slots : [];
        this.setState({ checkedSlots: slots.map(() => false) });
    }

    componentDidUpdate(prevProps) {
        // Reset when navigating to a different action/page
        if (
            prevProps.orderActionsIndex !== this.props.orderActionsIndex ||
            prevProps.currentOrderAction !== this.props.currentOrderAction
        ) {
            const { currentOrderAction } = this.props;
            const slots = Array.isArray(currentOrderAction?.slots) ? currentOrderAction.slots : [];
            this.setState({
                codeConfirmed: false,
                userInput: "",
                checkedSlots: slots.map(() => false), // reset by index
                errorMsg: "",                         // clear any prior error
                showInstructions: false                        // <-- close tooltip on page change
            });
        }

        const inputField = document.getElementById('order-action-input');
        if (inputField) {
            inputField.focus();
        }
    }

    handleInputChange(e) {
        const { value } = e.target;
        const expectedCode = this.props.currentOrderAction.code;
        const normalizedExpected = expectedCode ? String(expectedCode).trim() : "";
        const normalizedValue = String(value).trim();

        this.setState(prev => ({
            userInput: value,
            // clear the error as soon as they type again
            errorMsg: prev.errorMsg ? "" : prev.errorMsg,
            codeConfirmed: !!normalizedExpected && normalizedValue === normalizedExpected
        }));
    }

    // Handle Enter key to validate and show message / clear field
    handleKeyDown(e) {
        if (e.key !== 'Enter') return;

        const expectedCode = this.props.currentOrderAction.code;
        const normalizedExpected = expectedCode ? String(expectedCode).trim() : "";
        const normalizedValue = String(this.state.userInput).trim();

        // Only act when there is an expected code
        if (!normalizedExpected) return;

        if (normalizedValue === normalizedExpected) {
            this.setState({ codeConfirmed: true, errorMsg: "" });
        } else {
            this.setState({
                errorMsg: `Code is wrong. Expected: ${normalizedExpected}`,
                userInput: "",
                codeConfirmed: false
            });
        }
    }

    toggleSlot(index) {
        this.setState(prev => {
            const next = prev.checkedSlots.slice();
            next[index] = !next[index];
            return { checkedSlots: next };
        });
    }

    // NEW: tap/click to toggle tooltip
    toggleInstructions() {
        this.setState(prev => ({ showInstructions: !prev.showInstructions }));
    }

    render() {
        const { currentOrderAction } = this.props;
        const { code, name, instructions, slots = [], sopInfo } = currentOrderAction;

        const allChecked = slots.length
            ? slots.every((_, idx) => !!this.state.checkedSlots[idx])
            : true;

        return (
            <div className="order-actions">
                <div className="title">
                    <h3>
                        {name}
                        {instructions && (
                            <button
                                type="button"
                                className="info-tip-trigger"
                                aria-label="Extra instructions"
                                aria-expanded={this.state.showInstructions}
                                aria-haspopup="dialog"
                                onClick={this.toggleInstructions}
                            >
                                <FontAwesomeIcon className="imageIcon" size="lg" icon={faCircleInfo} />
                            </button>
                        )}
                    </h3>
                </div>
                <div className="instructions">
                    {
                        instructions && this.state.showInstructions && <h4>{instructions}</h4>
                    }
                </div>

                {code && !this.state.codeConfirmed && (
                    <div className="navigation">
                        <p>Enter confirmation code to continue:</p>
                        <input
                            type="text"
                            value={this.state.userInput}
                            onChange={this.handleInputChange}
                            onKeyDown={this.handleKeyDown}
                            placeholder="Enter code"
                            id="order-action-input"
                            autoComplete="off"
                            aria-invalid={!!this.state.errorMsg}
                            aria-describedby={this.state.errorMsg ? "order-action-error" : undefined}
                        />
                        {this.state.errorMsg && (
                            <p
                                id="order-action-error"
                                className="input-error"
                                role="alert"
                                style={{ marginTop: 8 }}
                            >
                                {this.state.errorMsg}
                            </p>
                        )}
                    </div>
                )}

                <div className="slots">
                    <div className="slots-table-wrap">
                        <table className="slots-table" aria-label="Slots checklist">
                            <thead>
                                <tr>
                                    <th className="slot-col">Slot</th>
                                    <th className="rule-col">Message</th>
                                    <th className="check-col">Done</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sopInfo && sopInfo.map((sop, idx) => {
                                    const checked = !!this.state.checkedSlots[idx];
                                    return (
                                        <tr
                                            key={idx}
                                            className={`slot-row${checked ? ' is-checked' : ''}`}
                                        >
                                            <td className="slot-name">{String(sop.orderActionInfo.slot)}</td>
                                            <td className="slot-message">{sop.orderActionInfo.slot_message}</td>
                                            <td className="slot-check">
                                                <label className="check-wrap">
                                                    <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        onChange={() => this.toggleSlot(idx)}
                                                        aria-label={`Mark slot ${idx + 1} complete`}
                                                    />
                                                    <span className="check-faux" />
                                                </label>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="navigation">
                    <div className="buttons">
                        {this.props.orderActionsIndex > 0 && (
                            <button className="back" onClick={() => { this.props.displayOrderAction(true); }}>Back</button>
                        )}
                        {(!code || this.state.codeConfirmed) && allChecked && (
                            <button className="continue" onClick={() => { this.props.displayOrderAction(false); }}>Continue</button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
